import { render, staticRenderFns } from "./HeaderPurchase.vue?vue&type=template&id=8a4531d4&"
import script from "./HeaderPurchase.vue?vue&type=script&lang=js&"
export * from "./HeaderPurchase.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports